export default "__VITE_ASSET__BnizOg0s__"